// eslint-disable-next-line import/no-extraneous-dependencies
import {
    BlacklistStatus,
} from 'pando-constants';

export const blacklistStatusList = [
    { id: BlacklistStatus.BLACKLIST, name: 'Blacklist', tlabel: 'INDENT_BLACKLIST' },
    { id: BlacklistStatus.UNBLACKLIST, name: 'Unblacklist', tlabel: 'INDENT_UNBLACKLIST' },
];
